































import Component, { mixins } from "vue-class-component";
import Main from "@/components/app/Main.vue";
import OfficeSelect from "@/components/app/OfficeSelect.vue";
import InlineFrame from "@/components/app/InlineFrame.vue";
import HonobonoInlineFrame from "@/components/app/HonobonoInlineFrame.vue";
import MockToken from "@/components/app/MockToken.vue";
import DirectAccessError from "@/components/app/DirectAccessError.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import Cookies from "js-cookie";

window.axios = require("axios");

window.base_url = process.env.VUE_APP_BACKEND_URL;
if (!window.base_url) {
  window.base_url = "/receipt-server";
}

window.mode = process.env.VUE_APP_MODE;
if (!window.mode) {
  window.mode = "development";
}

window.auth_backend_url = process.env.VUE_APP_AUTH_BACKEND_URL;
if (!window.auth_backend_url) {
  window.auth_backend_url = "/auth-server";
}

window.ibow_frontend_url = process.env.VUE_APP_IBOW_FRONTEND_URL;
if (!window.ibow_frontend_url) {
  window.ibow_frontend_url = "http://localhost:9000";
}

window.cookie_domain = process.env.VUE_APP_COOKIE_DOMEIN;
if (!window.cookie_domain) {
  window.cookie_domain = "localhost";
}

window.is_trial = false;

@Component({
  components: {
    Main,
    OfficeSelect,
    InlineFrame,
    MockToken,
    DirectAccessError,
    HonobonoInlineFrame
  }
})
export default class App extends mixins(AxiosMixin) {
  private isSelect = false; //事業所選択済
  private isToken = false; //トークン認証済
  private isAgree = false; //テスト版同意済
  private isHonobono = false; //ほのぼの有
  private opelogEnabled = false; // iBowレセプトオペログ画面表示フラグ
  private mode = window.mode;
  private isUserInfoLoading = false; // ログインユーザー情報取得中フラグ

  created() {
    // iBowから遷移した際は中間ページ表示
    if (location.href.indexOf("?fromIbow=1") != -1) {
      Cookies.set("isAgree", "");
      Cookies.set("office_id", "");
    }

    // セッションが切れた場合
    const url = new URL(window.location.href);
    const params = url.searchParams;
    if (params.get("isTimeout")) {
      return;
    }

    // 開発時は認証しない
    if (this.mode == "development") {
      this.isToken = true;
      this.isAgree = true;
      this.isSelect = true;
      return;
    }

    const token = Cookies.get("token");
    const refToken = Cookies.get("reftoken");

    // 認証済みの場合
    if (token && refToken) {
      window.token = token;
      window.reftoken = refToken;
      this.token();
      const isAgree = Cookies.get("isAgree");
      if (isAgree) {
        this.attention();
      }
      this.isUserInfoLoading = true;
      // ログインユーザー情報取得
      this.postJsonCheck(window.base_url + "/api/userinfo/get", {}, res => {
        window.user_name = res.data.user_name;
        window.auth_id = res.data.auth_id;
        this.isHonobono = res.data.isHonobono;
        this.opelogEnabled = res.data.is_receipt_opelog_enabled;
        let officeName = Cookies.get("office_name");
        let officeId = Cookies.get("office_id");

        // iBowから遷移した場合、取得した事業所を選択
        if (Number(officeId) == 0) {
          officeName = res.data.office_name;
          officeId = res.data.office_id;
        }
        this.setOffice(Number(officeId), String(officeName));
      });
    } else {
      // 認証情報がない場合はiBowに飛ばす
      // location.href = window.ibow_frontend_url;
    }
  }

  // 選択中の事業所情報をセットする
  private setOffice(officeId: number, officeName: string) {
    // 事業所未選択、かつ、iBow所属事業所、または、所属事業所があれば事業所選択画面を出さない
    if (!this.isSelect && officeId > 0) {
      // 選択中の事業所をセットしたトークンを発行する
      this.postJsonCheck(
        window.auth_backend_url + "/outer/auth/receiptoffice/token",
        {
          receipt_office_id: officeId
        },
        res => {
          window.token = res.data.token;
          //レセプト用のトークンはcookieに記憶しない
          //   Cookies.set("token", window.token);
          window.reftoken = res.data.ref_token;
          //レセプト用のトークンはcookieに記憶しない
          //   Cookies.set("reftoken", window.reftoken);
          window.office_name = officeName;
          Cookies.set("office_name", window.office_name);
          this.isSelect = true;
          this.isUserInfoLoading = false;
        }
      );
    } else {
      this.isUserInfoLoading = false;
    }
  }

  private token() {
    this.isToken = true;
  }

  private attention() {
    this.isAgree = true;
  }

  private select() {
    this.isSelect = true;
  }

  private selectOff() {
    if (this.$router.currentRoute.path == "/") {
      this.isSelect = false;
    }
    this.$router.push({ path: "/" }, () => {
      this.isSelect = false;
    });
  }
}
